import React, {useContext, useState, useEffect, useCallback} from "react";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faEdit, faPlus} from "@fortawesome/free-solid-svg-icons";

// Contexts
import {AuthContext} from "../../contexts/auth.js";

// Hooks
import useApi from "../../hooks/useApi.js";
import useMountedState from "../../hooks/useMountedState.js";

// Components
import BaseTable from "../../components/BaseTable.js";
import ModalRegion from "./ModalRegion.js";

// Style
import {
  Button,
  Heading,
  Inline,
  TableWrapper,
  TableHeaderWrap,
  TableMenu
} from "../../style/components/general.js";

const TableRegions = () => {
  const isMounted = useMountedState();

  const {atLeast} = useContext(AuthContext);
  const canManage = atLeast("creator");

  const [regions, setRegions] = useState(null);
  const [loading, setLoading] = useState(true);
  const [selected, setSelected] = useState(null);
  const [showModal, setShowModal] = useState(false);

  const {api} = useApi("regions", {suppress: {success: true}});

  const getRegions = useCallback(() => {
    setLoading(true);
    api.callGet().then(response => {
      if (isMounted() && response?.status === 200) setRegions(response.data);
      if (isMounted()) setLoading(false);
    });
  }, [api, isMounted]);

  useEffect(() => {
    getRegions();
  }, [getRegions]);

  const openModal = region => {
    setSelected(region);
    setShowModal(true);
  };

  return (
    <>
      <TableWrapper>
        <TableHeaderWrap>
          <Inline>
            <Heading>Regions</Heading>
            <TableMenu>
              {canManage && (
                <Button
                  type="button"
                  aria-label="add region"
                  data-testid="openRegionModal"
                  title="Add Region"
                  onClick={() => openModal(null)}>
                  <FontAwesomeIcon icon={faPlus} />
                </Button>
              )}
            </TableMenu>
          </Inline>
        </TableHeaderWrap>
        <BaseTable
          headings={{
            id: {header: "", disabled: true},
            name: {header: "Name", disabled: true},
            ...(canManage && {options: {header: "Options", disabled: true}})
          }}
          data={
            regions?.map(region => ({
              id: region.id,
              name: (region.name ?? "").toUpperCase(),
              ...(canManage && {
                options: (
                  <Button type="button" title="Edit Region" onClick={() => openModal(region)}>
                    <FontAwesomeIcon icon={faEdit} />
                  </Button>
                )
              })
            })) || null
          }
          loading={loading}
          dataMissing="No regions found"
        />
      </TableWrapper>

      {showModal && (
        <ModalRegion
          visible={showModal}
          setVisible={setShowModal}
          region={selected}
          update={getRegions}
        />
      )}
    </>
  );
};

export default TableRegions;
